/* eslint-disable import/no-unused-modules */
import PolarstepsAlternative from 'components/StartBlog/PolarstepsAlternative';
import withApollo from '../lib/withApollo';

// Head-to-head lander of the blogger-intent SEO cluster (docs/seo-plan.md §3).
const PolarstepsAlternativePage = () => <PolarstepsAlternative />;

export default withApollo(PolarstepsAlternativePage);
